// DEPENDENCIES
import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
// COMPONENTS
import { Link } from 'react-router-dom';
import MUIDataTable from "mui-datatables";
import SVG from "react-inlinesvg";
import { Spinner } from "react-bootstrap";
// CUSTOM COMPONENTS
import * as alert from "../../../../redux/alertSnackBarRedux";
import * as confirmModal from "../../../../redux/confirmModalRedux";
// SERVICES AND HELPERS
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import * as jobService from "../../../../services/service/jobService";

const completeJobModel = {
    id: 0,
    userId: 0,
    completedDateTime: ''
}

const JobListingCompletedPage = (props) => {
    const { showAlert, showConfirmModal, hideConfirmModal, auth } = props;
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadJobs();
    }, [])

    const loadJobs = () => {
        jobService.getCompletedJobs().then(res => {
            setData(res);
            setLoading(false);
        }).catch(ex => console.log(ex))
    }

    const deleteJob = (id) => {
    }

    const reactivateJob = (id) => {
        setLoading(true);
        jobService.completeJob({ ...completeJobModel, id: id, userId: 0, completedDateTime: ''}).then(res => {
            showAlert({ message: res.message, variant: 'success' })
            hideConfirmModal();
            loadJobs();
        }).catch(err => {
            console.log(err);
            showAlert({ message: err.message, variant: 'error' });
            setLoading(false);
        })
    }

    const columns = [
        {
            name: "id",
            label: "Actions",
            options: {
                filter: false,
                sort: false,
                width: 15,
                download: false,
                setCellProps: () => ({ style: { width: "20%" } }),
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <>
                            {
                                auth.isAdmin &&
                                <Link
                                    to={"/services/manage-job/general-information/" + data[dataIndex].id}
                                    className="btn btn-sm btn-info font-weight-bold py-2 px-3 px-xxl-5"
                                >
                                    View
                                </Link>

                                
                            }
                            &nbsp;
                            {/* <button
                                onClick={() => showConfirmModal({
                                    title: "Delete Job",
                                    text: "Are you sure you want to delete this job?",
                                    rightBtnText: "Confirm",
                                    btnAction: () => deleteJob(data[dataIndex].id)
                                })}
                                className="btn btn-sm btn-danger font-weight-bold py-2 px-3 px-xxl-5 my-1"
                            >
                                Delete
                            </button> */}
                             {auth.isAdmin &&
                                <button
                                    onClick={() => showConfirmModal({
                                        title: "Reactivate Job",
                                        text: "Are you sure you want to re-activate this job?",
                                        rightBtnText: "Confirm",
                                        btnAction: () => reactivateJob(data[dataIndex].id)
                                    })}
                                    className="btn btn-sm btn-success font-weight-bold py-2 px-3 px-xxl-5 my-1"
                                >
                                    Reactivate
                                </button>
                            }
                        </>
                    );
                }
            },

        },
        {
            name: "projectNumber",
            label: "Project Number",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "projectName",
            label: "Project Name",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "client",
            label: "Client",
            options: {
                filter: true,
                sort: true,
            }
        }
    ];


    return (
        <div className="row" >
            <div className="col-lg-12 col-xxl-12">
                <div className={`card card-custom card-stretch gutter-b}`}>
                    <div className="card-header border-0 py-5">
                        <h3 className="card-title align-items-start flex-column">
                            <span className="card-label font-weight-bolder text-dark">
                                Completed Jobs
                            </span>
                            <span className="text-muted mt-3 font-weight-bold fz-xs">
                                View and Manage Jobs
                            </span>
                        </h3>
                    </div>
                    <div className="container-fluid">
                        <MUIDataTable
                            data={data}
                            columns={columns}
                            options={{
                                rowsPerPage: 50,
                                rowsPerPageOptions: [10, 15, 20, 25, 30, 35, 40, 45, 50, 100],
                                selectableRows: 'none',
                                textLabels: {
                                    body: {
                                        noMatch: loading ?
                                            <Spinner animation="border" size="lg" variant="info" /> :
                                            'Sorry, no matching records found.',
                                    },
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
        </div >
    )
}

const mapStateToProps = (state) => ({
    auth: state.auth
});

export default connect(mapStateToProps, { ...alert.actions, ...confirmModal.actions })(JobListingCompletedPage);